import KpiGraphDashboardDashboard from "./template/KpiGraphDashboard";
import StrategicPlanningDashboard from "./template/StrategicPlanningDashboard";
import EmbeddedLinkDashboard from "./template/EmbeddedLinkDashboard";

const layout = {
    KPI_GRAPH_DASHBOARD: 1,
    STRATEGIC_PLANNING_DASHBOARD: 2,
    EMBEDDED_LINK_DASHBOARD: 3,
};

export default function TemplateSelector(props) {
    const { layoutId, dashboard } = props;

    switch (layoutId) {
        case layout.KPI_GRAPH_DASHBOARD:
            return <KpiGraphDashboardDashboard dashboard={dashboard} />;
        case layout.STRATEGIC_PLANNING_DASHBOARD:
            return <StrategicPlanningDashboard dashboard={dashboard} />;
        case layout.EMBEDDED_LINK_DASHBOARD:
            return <EmbeddedLinkDashboard dashboard={dashboard} />;
        default:
            return "ERROR - missing dashboard layout.";
    }
}
